module.exports = "<div style=\"height:100%;width:100%;\" fxLayout=\"column\">\n  <div fxFlex=\"50\" fxLayoutAlign=\"center center\">\n    <div>Please select {{data.name}} </div>\n  </div>\n\n  <div fxFlex=\"50\" mat-dialog-actions fxLayoutAlign=\"center center\">\n    <button mat-button [mat-dialog-close]=\"data.animal\" cdkFocusInitial>Ok</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bookShared/bookeditoption/bookeditalertdialog.html
// module id = ./src/app/bookShared/bookeditoption/bookeditalertdialog.html
// module chunks = main